import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * Where the flows admin links to. The standard pages live under /admin; a route that hosts the flows admin
 * elsewhere (the order parser's Flows tab) sets `data.gungFlowsBasePath`, so opening, saving or deleting a
 * flow keeps the user in that section.
 */
@Injectable({
  providedIn: 'root'
})
export class GungFlowNavigationService {
  protected router = inject(Router);

  listUrl(): string {
    return this.basePath() || '/admin/gung-flows';
  }

  detailsUrl(flowId: string): string {
    const basePath = this.basePath();
    return basePath ? `${basePath}/${flowId}` : `/admin/gung-flow-details/${flowId}`;
  }

  protected basePath(): string | undefined {
    let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.data?.['gungFlowsBasePath'];
  }
}
